import type { SGWTConnectCore } from '@sgwt/connect-core';
import type { Http } from '@/utils/http';
import { catchError } from 'rxjs/operators';
import { logger } from '@/logging/logger';
import { throwError } from 'rxjs';

export type HelpRequestConfig = 'appcrashed' | 'timeouteddeal' | 'afwpredeliver'; // support.address.<config> must exist in XOne.Host App.config

export interface IHelpRequestAdditionalParams {
  application: 'SGME-MY-FX';
  config?: HelpRequestConfig;
  details?: string;
  data?: object;
  screenshot?: string;
  templateId?: number;
  templateIdConfirmation?: number;
}

export const sendHelpRequest = (http: Http, sgwtConnectParam: SGWTConnectCore) => (helpRequestParam: IHelpRequestAdditionalParams) => {
  const { userAgent } = navigator;

  // user info is extracted from sgwtConnect
  const login = sgwtConnectParam.getIdTokenClaims()!.sub as string;
  const payload = {
    ...helpRequestParam,
    login,
    userAgent,
  };

  try {
    logger.logInformation('Sending help request {@helpRequestBody}', {
      login,
      userAgent,
      helpRequestParam,
    });
  } catch (err) {
    logger.logError('Log info failed, need to reduce helpRequestBody');
  }
  return http
    .post('help/request/v2', payload, {
      'Content-Type': 'application/json',
    })
    .pipe(
      catchError((err) => {
        logger.logError('Error while sending help request {message_s}', err.message);
        if (err.status === 413) {
          delete payload.screenshot;
          payload.details = `[state and screenshot missing because of error 413, screenshot size was ${helpRequestParam?.screenshot?.length
            }]\n\n${helpRequestParam?.details || ''}`;
          return http.post('help/request/v2', payload, {
            'Content-Type': 'application/json',
          });
        }
        return throwError(err);
      }),
    );
};
